import * as yup from "yup";

export const MinimumWageRateSetupValidationSchema = yup.object().shape({
  province: yup
  .string()
  .required("Province is required"),
	minWageRate: yup
  .string()
  .required("Min Wage Rate is required")
  .max(999.99, "Maximum length 999.99 characters"),
  dateEffective: yup
  .string()
  .required("Date Effective is required"),
  type: yup
  .number()
  .required("Type is required"),
});
